import React, { Component } from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TimelineMax } from 'gsap/all'

const Container = styled.div`
  width: auto;
  height: 100%;
  overflow: hidden;
`

const ImageHolder = styled.div`
  // opacity: 0;
`

const StyledImg = styled(Img)`
  height: 100%;
`

export default class RevealImage extends Component {
  static contextTypes = {
    scrollmagic: PropTypes.any,
  }

  constructor(props) {
    super(props)

    this.item = null
    this.animation = new TimelineMax({ paused: true })
  }

  componentDidMount() {
    // const { scrollMagic, callback } = this.props
    // const { Scene } = scrollMagic
    // const yMove = this.getRandomInt(10)

    // this.animation
    //   .set(this.item, { css: { animation: 'none' } })
    //   .to(this.image, 1.3, {
    //     opacity: 1,
    //     ease: 'Power0.easeNone',
    //     delay: 0.4,
    //   })
      // .to(this.image, 1, {
      //   y: `-=${yMove}`,
      //   ease: 'Linear.easeNone',
      // }, '-=0.3')

    // this.scene = new Scene({
    //   triggerElement: this.item,
    //   triggerHook: 1.8,
    //   offset: 120,
    // })
    // this.scene.on('enter', () => {
    //   // this.animation.play()
    //   if (callback) {
    //     callback()
    //   }
    // })
    // this.scene.addTo(this.context.scrollmagic)
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max))
  }

  render() {
    const { image } = this.props
    return (
      <Container ref={c => { this.item = c }}>
        <ImageHolder
          ref={c => { this.image = c }}
        >
          <StyledImg fluid={image} />
        </ImageHolder>
      </Container>
    )
  }
}
